import { Navigate } from '@tanstack/react-router';
import { DASHBOARD, PROTECTED } from '@/lib/constants/routes';

interface RoleGuardProps {
  hasAccess: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
}

export function RoleGuard({ hasAccess, isLoading, children }: RoleGuardProps) {
  if (isLoading) return null;

  if (!hasAccess) {
    return <Navigate to={`${PROTECTED}${DASHBOARD}`} replace />;
  }

  return <>{children}</>;
}
